import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
export const PrintCard = lazy(() => import('@project/routes/pages/PrintCard'));

export const PrintCardRoutes = () => {
  return (
    <Routes>
      <Route element={<PrintCard />} />
    </Routes>
  );
};
